import { parseBorderWidth, parsePadding } from "@common/lib/css";

export const getRadioButtonStyle = (
  index: number,
  length: number,
  activeOptionIndex: number,
  fieldStyle?: React.CSSProperties
): React.CSSProperties | undefined => {
  if (!fieldStyle) return;

  const paddings = parsePadding(fieldStyle);
  const borderWidth = parseBorderWidth(fieldStyle);
  return {
    paddingLeft: paddings?.left,
    paddingRight: paddings?.right,
    paddingTop: paddings?.top,
    paddingBottom: (!borderWidth?.top || borderWidth?.top === "0px") && index !== length - 1 ? 0 : paddings?.bottom,
    borderColor: fieldStyle.borderColor,
    borderTopColor:
      activeOptionIndex !== -1 && activeOptionIndex + 1 === index ? "var(--color)" : fieldStyle.borderColor,
    borderLeftWidth: borderWidth?.left,
    borderRightWidth: borderWidth?.right,
    borderTopWidth: borderWidth?.top,
    borderBottomWidth: index === length - 1 ? borderWidth?.bottom : 0,
    borderStyle: fieldStyle?.borderStyle,
    margin: 0,
    borderTopRightRadius: index === 0 ? fieldStyle.borderTopRightRadius ?? fieldStyle.borderRadius : 0,
    borderTopLeftRadius: index === 0 ? fieldStyle.borderTopLeftRadius ?? fieldStyle.borderRadius : 0,
    borderBottomLeftRadius: index === length - 1 ? fieldStyle.borderBottomLeftRadius ?? fieldStyle.borderRadius : 0,
    borderBottomRightRadius: index === length - 1 ? fieldStyle.borderBottomRightRadius ?? fieldStyle.borderRadius : 0
  };
};

export const getRadioButtonGroupStyle = (fieldStyle?: React.CSSProperties): React.CSSProperties | undefined => {
  if (!fieldStyle) return;

  return {
    ...fieldStyle,
    gap: 0,
    padding: 0,
    borderColor: "unset",
    borderWidth: 0,
    borderTopRightRadius: fieldStyle?.borderTopRightRadius ?? fieldStyle?.borderRadius,
    borderTopLeftRadius: fieldStyle?.borderTopLeftRadius ?? fieldStyle?.borderRadius,
    borderBottomLeftRadius: fieldStyle?.borderBottomLeftRadius ?? fieldStyle?.borderRadius,
    borderBottomRightRadius: fieldStyle?.borderBottomRightRadius ?? fieldStyle?.borderRadius
  };
};
